import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const giftsCounts = createAsyncThunk(
  "giftsCounts/giftsCounts",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("gift/get-all-gifts-count");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const giftCountsSlice = createSlice({
  name: "giftsCounts",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(giftsCounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(giftsCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(giftsCounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default giftCountsSlice.reducer;
